import axios, { AxiosRequestConfig } from 'axios';
import qs from 'qs';
import { setupCache } from 'axios-cache-adapter';

import {
  API_HOST,
  DEFAULT_HEADERS,
} from './utils';
import { authInterceptor, errorInterceptor, responseInterceptor } from './utils/interceptors';

const cache = setupCache({
  maxAge: 0, // 15 * 60 * 1000
  exclude: { query: false },
});

const DEFAULT_API_CONFIG: AxiosRequestConfig = {
  baseURL: API_HOST,
  timeout: 20000,
  headers: DEFAULT_HEADERS,
  withCredentials: true,
  adapter: cache.adapter,
  paramsSerializer: (params) => qs.stringify(params, { encode: false }),
};

const httpClient = axios.create(DEFAULT_API_CONFIG);

httpClient.interceptors.request.use(authInterceptor);
httpClient.interceptors.response.use(responseInterceptor, errorInterceptor);

export default httpClient;
